export default __webpack_public_path__ + "static/media/casual-kid.3202c3cd.jpg";